/**
 * Textarea class for enhanced functionality
 */

export class Textarea {

	constructor(elem) {
		this.elem = elem;
		this.textareaLineheight = 24; // Not using window.getComputedStyle() because of preformance
		this.showLines = 3;
		this.addEventHandlers();
		this.init();
	}

	static getSelector() {
		return 'textarea';
	}

	init() {
		this.setElemHeight();
	}

	/**
	 * add all event handlers
	 *
	 * @returns {void}
	 */
	addEventHandlers() {
		this.elem.addEventListener('input', () => {
			this.setElemHeight();
		}, false);
		this.elem.addEventListener('blur', () => {
			this.setElemHeight();
		});
	}

	setElemHeight() {
		const maxHeight = 90;
		this.elem.style.maxHeight = `${maxHeight}px`;
		const textareaHeight = this.countLines() > this.showLines ? this.elem.scrollHeight + 15 : this.elem.scrollHeight;
		this.elem.style.height = `${this.elem.value === '' ? maxHeight : textareaHeight}px`;
		this.elem.style.maxHeight = 'none';
	}

	countLines() {
		return this.elem.scrollHeight / this.textareaLineheight;
	}

}
